import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './DentistNavbar1.css';

const DentistNavbar1 = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdown) => {
    if (isMobile) {
      setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
    }
  };

  const handleMouseEnter = (dropdown) => {
    if (!isMobile) {
      setActiveDropdown(dropdown);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setActiveDropdown(null);
    }
  };

  // Handle window resize
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setActiveDropdown(null);
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav className="dentist-navbar">
      <div className="navbar-container">
        {/* Logo Section */}
        <div className="navbar-logo">
          <div className="logo-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2M21 9V7L15 1H5C3.89 1 3 1.89 3 3V21C3 22.11 3.89 23 5 23H19C20.11 23 21 22.11 21 21V9M19 9H14V4H5V21H19V9Z"/>
            </svg>
          </div>
          <div className="logo-text">
            <span className="clinic-name">Prime Care</span>
            <span className="clinic-subtitle">Dental Clinic</span>
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
        </div>

        {/* Navigation Menu */}
        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/" className="nav-link">Home</Link>
            </li>
            
            <li 
              className="nav-item dropdown"
              onMouseEnter={() => handleMouseEnter('services')}
              onMouseLeave={handleMouseLeave}
            >
              
              <button 
                className="nav-link dropdown-toggle"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown('services');
                }}
              >
                Services
                <svg className="dropdown-arrow" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 10L12 15L17 10H7Z"/>
                </svg>
              </button>
              <ul className={`dropdown-menu ${activeDropdown === 'services' ? 'active' : ''}`}>
                <li><Link to="/service/orthodontics" className="dropdown-link">Orthodontics</Link></li>
                <li><Link to="/service/implants" className="dropdown-link">Implants</Link></li>
                <li><Link to="/service/cosmetic" className="dropdown-link">Cosmetic Dentistry</Link></li>
                <li><Link to="/service/restorative" className="dropdown-link">Restorative Dentistry</Link></li>
                <li><Link to="/service/periodontics" className="dropdown-link">Periodontics</Link></li>
                <li><Link to="/service/surgery" className="dropdown-link">Oral Surgery</Link></li>
                <li><Link to="/service/tmj" className="dropdown-link">TMJ Disorders</Link></li>
                <li><Link to="/service/anesthesia" className="dropdown-link">Anesthesia Services</Link></li>
                <li><Link to="/services" className="dropdown-link">View All Services</Link></li>
              </ul>
            </li>

            <li 
              className="nav-item dropdown"
              onMouseEnter={() => handleMouseEnter('about')}
              onMouseLeave={handleMouseLeave}
            >
              <button 
                className="nav-link dropdown-toggle"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown('about');
                }}
              >
                About
                <svg className="dropdown-arrow" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 10L12 15L17 10H7Z"/>
                </svg>
              </button>
              <ul className={`dropdown-menu ${activeDropdown === 'about' ? 'active' : ''}`}>
                <li><Link to="/our-team" className="dropdown-link">Our Team</Link></li>
                <li><Link to="/testimonials" className="dropdown-link">Testimonials</Link></li>
              </ul>
            </li>

            <li className="nav-item">
              <Link to="/contact" className="nav-link">Contact</Link>
            </li>

            <li className="nav-item">
              <Link to="/write-for-us" className="nav-link">Write for us</Link>
            </li>
          </ul>

          {/* CTA Button */}
          <div className="navbar-cta">
            <Link to="/appointment" className="cta-button">
              <svg className="cta-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V8H19V19M7 10H12V15H7"/>
              </svg>
              Book Appointment
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default DentistNavbar1;
